import { captureException } from '@sentry/react';
import { useEffect, useState } from 'react';

import { type CreditDetails, getCreditDetails } from './credit-api';

type CreditLookup =
	| { status: 'loading' | 'failed' }
	| { status: 'loaded'; details: CreditDetails | null };

export const useCreditDetails = (cloudId: string) => {
	const [lookup, setLookup] = useState<CreditLookup>({ status: 'loading' });
	const [attempt, setAttempt] = useState(0);
	useEffect(() => {
		let active = true;
		const controller = new AbortController();
		const timeout = setTimeout(() => controller.abort(), 10000);
		getCreditDetails(cloudId, controller.signal)
			.then((details) => {
				if (active) setLookup({ status: 'loaded', details });
			})
			.catch((error) => {
				if (active) {
					captureException(error, {
						tags: { component: 'CreditRequestPage', operation: 'getCreditDetails' },
					});
					setLookup({ status: 'failed' });
				}
			})
			.finally(() => clearTimeout(timeout));
		return () => {
			active = false;
			controller.abort();
			clearTimeout(timeout);
		};
	}, [cloudId, attempt]);
	return {
		lookup,
		retry: () => {
			setLookup({ status: 'loading' });
			setAttempt((value) => value + 1);
		},
	};
};
